import { CaseEventType, EventModel } from 'api/model';
import useHasAccessToSharebox from 'hooks/useHasAccessToSharebox';
import { useMemo, useState } from 'react';

const shareboxEventTypes = new Set<CaseEventType>([
  CaseEventType.ShareboxKeyDroppedIn,
  CaseEventType.ShareboxKeyPickedUp,
]);

export interface EventFilter {
  name: string;
  eventTypes: Set<CaseEventType>;
}

export const commentEventFilter: EventFilter = {
  name: 'Kommentarer',
  eventTypes: new Set([
    CaseEventType.Comment,
    CaseEventType.InternalComment,
    CaseEventType.FlaggedForSpeeding,
    CaseEventType.DeviationReport,
    CaseEventType.CarParkPhoto,
    CaseEventType.CarKeyAndDrivingLicensePhoto,
    CaseEventType.CarKeyPhoto,
    CaseEventType.WorkGearPhoto,
  ]),
};

export const externalAdminEventFilter: EventFilter = {
  name: 'Extern admin',
  eventTypes: new Set([CaseEventType.ExternalAdminChange]),
};

// export const eventsEventFilter: EventFilter = {
//   name: 'Händelser',
//   eventTypes: new Set([
//     CaseEventType.CaseEdited,
//     CaseEventType.CasePending,
//     CaseEventType.CaseDeleted,
//     CaseEventType.AssignmentCreated,
//     CaseEventType.AssignmentEdited,
//     CaseEventType.AssignmentAssigned,
//     CaseEventType.AssignmentAccepted,
//     CaseEventType.AssignmentStarted,
//     CaseEventType.AssignmentArrived,
//     CaseEventType.AssignmentReturning,
//     CaseEventType.AssignmentCompleted,
//     CaseEventType.AssignmentDeleted,
//     CaseEventType.AssignmentApproved,
//     CaseEventType.AssignmentDeclined,
//     CaseEventType.AssignmentTestComplete,
//     CaseEventType.CustomerStatusSMSSuccess,
//     CaseEventType.CustomerStatusSMSFail,
//   ]),
// };

export const rideUpdatesEventFilter: EventFilter = {
  name: 'Ride',
  eventTypes: new Set([CaseEventType.RideChange, CaseEventType.RideComment]),
};

// export const customerUpdateSMSFilter: EventFilter = {
//   name: 'SMS-uppdateringar',
//   eventTypes: new Set([
//     CaseEventType.CustomerStatusSMSSuccess,
//     CaseEventType.CustomerStatusSMSFail,
//   ]),
// };

export function applyEventFilter(
  events: EventModel[],
  eventFilter: EventFilter
) {
  return events.filter((eve) => eventFilter.eventTypes.has(eve.caseEventType));
}

const useFilteredEvents = (events: EventModel[]) => {
  const [selectedFilter, setSelectedFilter] = useState<EventFilter | null>(
    null
  );
  const [selectedAssignmentId, setSelectedAssignmentId] = useState<
    number | null
  >(null);
  const hasAccessToSharebox = useHasAccessToSharebox();

  return useMemo(() => {
    let filtered = selectedFilter
      ? applyEventFilter(events, selectedFilter)
      : events;

    // Sharebox-nyckelhändelser skrivs alltid, men visas bara för piloten.
    if (!hasAccessToSharebox) {
      filtered = filtered.filter(
        (e) => !shareboxEventTypes.has(e.caseEventType)
      );
    }

    if (selectedAssignmentId !== null) {
      filtered = filtered.filter(
        (e) => e.assignmentID === selectedAssignmentId
      );
    }

    return {
      events: filtered
        .slice()
        .sort((a, b) => ((a.created ?? 0) > (b.created ?? 0) ? -1 : 1)),

      selectedFilter,
      setSelectedFilter,
      selectedAssignmentId,
      setSelectedAssignmentId,
    };
  }, [events, selectedFilter, selectedAssignmentId, hasAccessToSharebox]);
};

export default useFilteredEvents;
